import React from 'react';

const TabNavigation = ({ searchData, activeTab, onTabClick, getIcon, getTabLabel }) => {

    if (!searchData) return null;

    const renderTab = (key, data, idEtp = null) => {
        const isActive = activeTab === key;
        const count = data.count || 0;

        if (count === 0) return null;

        return (
            <button
                key={`${key}-${idEtp || 'no-idetp'}`}
                onClick={() => {
                    onTabClick(key, data.route, idEtp);
                }}
                className={`
                    flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-all duration-200
                    ${isActive
                        ? 'bg-blue-600 text-white shadow-lg'
                        : 'bg-white text-gray-700 hover:bg-blue-50 hover:text-blue-600 border border-gray-200'
                    }
                `}
            >
                {getIcon(key)}
                <span>{getTabLabel(key)}</span>
                <span className={`
                    px-2 py-1 text-xs rounded-full
                    ${isActive ? 'bg-blue-500 text-white' : 'bg-gray-100 text-gray-600'}
                `}>
                    {count}
                </span>
            </button>
        );
    };

    const tabs = [];

    // Regular tabs
    Object.entries(searchData).forEach(([key, value]) => {
        if (key !== 'project_with_client' && value && typeof value === 'object' && !Array.isArray(value)) {
            tabs.push(renderTab(key, value));
        }
    });

    // Project with client tabs
    if (searchData.project_with_client && Array.isArray(searchData.project_with_client)) {
        searchData.project_with_client.forEach((project, index) => {
            tabs.push(renderTab(project.type, project, project.idEtp));
        });
    }

    return (
        <div className="mb-6">
            <div className="flex flex-wrap gap-2">
                {tabs.filter(Boolean)}
            </div>
        </div>
    );
};

export default TabNavigation;